// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./help_search"
import "@rails/actioncable"
import "sortablejs"

// Import Action Text components
import "trix"
import "@rails/actiontext"

// Chart.js date adapter for time-series charts (required by Chartkick)
import "chartjs-adapter-date-fns"

// Import Turbo-ready helper for inline scripts
import turboReady from './utils/turbo_ready'

// Import Spotify app opener utility
import './utils/spotify_app_opener'

// Import Analytics tracking
import './analytics'

// Location-based club selector removed - manual selection only

// Make turboReady available globally for inline scripts
window.turboReady = turboReady

// Configure Turbo for better mobile performance
Turbo.config.drive.progressBarDelay = 100 // Show progress bar faster on slow connections

// Initialize Trix editors efficiently
function initializeTrixEditors() {
  // Only initialize editors that haven't been initialized
  document.querySelectorAll("trix-editor:not([data-trix-initialized])").forEach(editor => {
    editor.dataset.trixInitialized = 'true'
    if (!editor.editor) {
      editor.dispatchEvent(new Event('trix-initialize'))
    }
  })
}

// Use Turbo events efficiently
document.addEventListener("turbo:load", () => {
  // Initialize Trix editors
  initializeTrixEditors()
  
  // Re-initialize Alpine.js components if present
  if (window.Alpine && !window.Alpine._initialized) {
    window.Alpine.initTree(document.body)
    window.Alpine._initialized = true
  }
  
  // Log only in development
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.log("🚀 Turbo navigation completed")
  }
})

// Clean up before caching
document.addEventListener("turbo:before-cache", () => {
  // Remove temporary elements
  document.querySelectorAll('[data-turbo-temporary]').forEach(el => el.remove())
  
  // Reset Alpine state if needed
  if (window.Alpine) {
    window.Alpine._initialized = false
  }
})

// Handle Turbo errors gracefully
document.addEventListener("turbo:frame-missing", (event) => {
  // Prevent console errors for missing frames
  event.preventDefault()
  console.warn("Turbo frame missing:", event.detail)
})

// Optimize for mobile: Disable Turbo cache on low-memory devices
if ('connection' in navigator) {
  const connection = navigator.connection
  if (connection && (connection.saveData || connection.effectiveType === 'slow-2g')) {
    Turbo.session.drive = false // Disable Turbo on very slow connections
  }
}

// Function is available globally through window scope if needed